const attachShadowCache = HTMLElement.prototype.attachShadow;
const focusCache = HTMLElement.prototype.focus;
export const applyDelegateFocusPolyfill = () => {
    var _a, _b, _c;
    if ((_c = (_b = (_a = document.createElement('div')).attachShadow) === null || _b === void 0 ? void 0 : _b.call(_a, { mode: 'open', delegatesFocus: true })) === null || _c === void 0 ? void 0 : _c.delegatesFocus)
        return; // browser support or already applied, no need to apply.
    // Some JS Dom environments (used for testing) have limited features. Seems best to disable the polyfill in these cases
    if ((typeof attachShadowCache !== 'function') || (typeof focusCache !== 'function'))
        return;
    // Need to extend the prototype
    Object.defineProperty(HTMLElement.prototype, 'attachShadow', {
        value(shadowConfig) {
            const shadowRoot = attachShadowCache.bind(this)(shadowConfig);
            if (shadowConfig.delegatesFocus === true) {
                // @ts-expect-error 2540. delegatesFocus override.
                shadowRoot.delegatesFocus = true;
                // Override focus behaviour if delegateFocus is set to true
                this.focus = () => {
                    var _a;
                    focusCache.bind(this)();
                    (_a = shadowRoot.querySelector('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')) === null || _a === void 0 ? void 0 : _a.focus();
                };
            }
            return shadowRoot;
        }
    });
};
